import { nothing } from 'lit-html';
import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './selection-card-group.lit.scss';

/**
 * @component {kat-selection-card-group} KatSelectionCardGroup will allow users to group selection cards with selection-type radiobutton
 * @guideline Do Ensure kat-selection-cards have "radio" selection-type.
 * @status Production
 * @theme flo
 * @example Basic {
 * "label":"Selection Card Group",
 *  "content": "
 * <kat-selection-card selection-type=\"radio\" title=\"First\" image>
 * <img slot=\"image\" src=\"https://m.media-amazon.com/images/G/01/katal/internal/SquareCat1.jpg\"></img>
 * <span slot=\"subtitle\">
 *      Subtitle
 *  </span>
 *   <div>
 *      Body content
 *  </div>
 * <div slot=\"footer\">
 *      Footer
 *  </div>
 * </kat-selection-card>
 * <kat-selection-card selection-type=\"radio\" title=\"Second\" image>
 * <img slot=\"image\" src=\"https://m.media-amazon.com/images/G/01/katal/internal/SquareCat1.jpg\"></img>
 * <span slot=\"subtitle\">
 *      Subtitle
 *  </span>
 *   <div>
 *      Body content
 *  </div>
 * <div slot=\"footer\">
 *      Footer
 *  </div>
 *  </kat-selection-card>
 * <kat-selection-card selection-type=\"radio\" title=\"Third\" image>
 * <img slot=\"image\" src=\"https://m.media-amazon.com/images/G/01/katal/internal/SquareCat1.jpg\"></img>
 * <span slot=\"subtitle\">
 *      Subtitle
 *  </span>
 *   <div>
 *      Body content
 *  </div>
 * <div slot=\"footer\">
 *      Footer
 *  </div>
 *  </kat-selection-card>
 * "}
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-selection-card-group')
export class KatSelectionCardGroup extends KatLitElement {
  /** The title of the whole group. */
  @property()
  label?: string;

  static get styles() {
    return [baseStyles, styles];
  }

  firstUpdated() {
    const slot = this.shadowRoot.querySelector('slot[role="selectiongroup"]');
    slot.addEventListener('slotchange', () => {
      const selectionCards = this.querySelectorAll('kat-selection-card');
      selectionCards.forEach(card => {
        card.addEventListener('click', this.handleChange.bind(this));
      });
    });
  }

  handleChange(e) {
    const selectionCards = this.querySelectorAll('kat-selection-card');
    const clickedCard = e.currentTarget;
    if (!clickedCard.disabled) {
      selectionCards.forEach(card => {
        const radioButton = card.shadowRoot.querySelector('kat-radiobutton');
        radioButton.checked = false;
        card.checked = false;
      });

      const clickedRadioButton =
        clickedCard.shadowRoot.querySelector('kat-radiobutton');
      clickedRadioButton.checked = true;
      clickedCard.checked = true;
    }
  }

  render() {
    return html` <div class="label default">
        <slot name="label">${this.label || nothing}</slot>
      </div>
      <div class="items">
        <slot role="selectiongroup"> </slot>
      </div>`;
  }
}
